const steps = [
  {
    number: '01',
    title: 'We Build Your System',
    description: 'Our team designs and implements a custom AI automation system tailored to your business needs and workflow.',
    visual: 'https://public.readdy.ai/ai/img_res/31c9452d2c137fc1a3ed6a1a1d7df654.jpg'
  },
  {
    number: '02',
    title: 'We Connect Your Leads',
    description: 'Integrate all your lead sources - phone calls, website forms, social media - into one intelligent system that never misses an opportunity.',
    visual: 'https://readdy.ai/api/search-image?query=Digital%20network%20connection%20visualization%20showing%20multiple%20lead%20sources%20converging%20into%20central%20AI%20hub%2C%20glowing%20connection%20lines%2C%20data%20flow%20streams%2C%20futuristic%20interface%20with%20cyan%20and%20blue%20lights%2C%20abstract%20tech%20connectivity%20concept%2C%20dark%20background%20with%20luminous%20pathways&width=600&height=400&seq=bayfront-connect-leads&orientation=landscape'
  },
  {
    number: '03',
    title: 'AI Handles Follow-Up',
    description: 'Your AI assistant automatically responds to inquiries, qualifies leads, sends follow-ups, and keeps prospects engaged until they book.',
    visual: 'https://readdy.ai/api/search-image?query=AI%20chatbot%20interface%20with%20automated%20message%20bubbles%2C%20intelligent%20conversation%20flow%2C%20robotic%20assistant%20responding%20to%20customer%20inquiries%2C%20futuristic%20communication%20dashboard%20with%20cyan%20glow%20effects%2C%20dark%20sleek%20interface%20showing%20automated%20follow-up%20sequences%20and%20smart%20replies&width=600&height=400&seq=bayfront-ai-followup&orientation=landscape'
  },
  {
    number: '04',
    title: 'You Book More Jobs',
    description: 'Watch your calendar fill up with qualified appointments while you focus on delivering excellent service and growing your business.',
    visual: 'https://readdy.ai/api/search-image?query=Digital%20calendar%20interface%20filled%20with%20confirmed%20appointments%2C%20success%20checkmarks%2C%20booking%20confirmations%2C%20revenue%20growth%20visualization%2C%20futuristic%20scheduling%20dashboard%20with%20cyan%20and%20green%20success%20indicators%2C%20professional%20business%20growth%20metrics%2C%20dark%20modern%20interface&width=600&height=400&seq=bayfront-book-jobs&orientation=landscape'
  }
];

export default function HowItWorks() {
  return (
    <section className="relative py-32 bg-gradient-to-b from-black via-[#050810] to-black overflow-hidden">
      {/* Central Glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[1000px] h-[1000px] bg-blue-600/10 rounded-full blur-3xl" />

      <div className="container mx-auto px-6 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-24 scroll-reveal">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-blue-400/10 border border-blue-400/30 backdrop-blur-sm mb-6">
            <span className="text-xs font-bold text-blue-400 tracking-wider uppercase">The Process</span>
          </div>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white">
            How Bayfront Intelligence Works
          </h2>
        </div>

        {/* Steps */}
        <div className="max-w-6xl mx-auto space-y-32">
          {steps.map((step, index) => (
            <div
              key={index}
              className={`flex flex-col ${index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'} items-center gap-12 lg:gap-20 scroll-reveal`}
            >
              {/* Content */}
              <div className="flex-1">
                <div className="relative inline-block mb-6">
                  <div className="text-7xl md:text-8xl font-bold text-transparent bg-clip-text bg-gradient-to-br from-cyan-400 to-blue-600 drop-shadow-[0_0_30px_rgba(0,212,255,0.5)]">
                    {step.number}
                  </div>
                  <div className="absolute -inset-4 bg-cyan-400/10 blur-2xl rounded-full -z-10" />
                </div>
                <h3 className="text-3xl md:text-4xl font-bold text-white mb-4">
                  {step.title}
                </h3>
                <p className="text-lg text-gray-400 leading-relaxed max-w-lg">
                  {step.description}
                </p>
              </div>

              {/* Visual */}
              <div className="flex-1 relative group">
                <div className="relative bg-white/5 backdrop-blur-xl border border-cyan-400/30 rounded-3xl overflow-hidden shadow-[0_0_60px_rgba(0,212,255,0.2)] transition-all duration-500 group-hover:shadow-[0_0_80px_rgba(0,212,255,0.4)] group-hover:scale-105">
                  <div className="aspect-[3/2] w-full h-full">
                    <img
                      src={step.visual}
                      alt={step.title}
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
                </div>

                {/* Connecting Line (except last step) */}
                {index < steps.length - 1 && (
                  <div className="hidden lg:block absolute left-1/2 -bottom-32 w-0.5 h-32 bg-gradient-to-b from-cyan-400 to-transparent">
                    <div className="absolute top-0 left-1/2 -translate-x-1/2 w-2 h-2 bg-cyan-400 rounded-full animate-pulse" />
                    <div className="absolute top-8 left-1/2 -translate-x-1/2 w-2 h-2 bg-cyan-400/60 rounded-full animate-pulse" style={{ animationDelay: '0.5s' }} />
                    <div className="absolute top-16 left-1/2 -translate-x-1/2 w-2 h-2 bg-cyan-400/30 rounded-full animate-pulse" style={{ animationDelay: '1s' }} />
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}